import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { ContactService } from '@pbx/services/ContactService';
import i18n from '@app/plugins/i18n';

class ContactModalService extends ModalService {
  constructor() {
    super(ContactService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.contact.modal.remove.content', {
        contact: `<strong>${[item.last_name, item.first_name].join(' ')}</strong>`
      })
    });
  }
}

const instance = new ContactModalService();
export { instance as ContactModalService };
